import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certidao-debito',
  templateUrl: './certidao-debito.component.html',
  styleUrls: ['./certidao-debito.component.css']
})
export class CertidaoDebitoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
